import { Text } from "@fluentui/react-components";
import { InfoRegular } from "@fluentui/react-icons";
import { devices } from "library/constants";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { useBenefitsData } from "hooks/useBenefitsData";

import { EligiblePackages } from "./EligiblePackages";
import { EnrolledPackages } from "./EnrolledPackages";

export function AllBenefits() {
  const { t } = useTranslation();
  const { enrolledFilteredData, eligibleFilteredData } = useBenefitsData();

  const noBenefits = enrolledFilteredData?.length === 0 && eligibleFilteredData?.length === 0;
  return noBenefits ? (
    <NoBenefitsText>
      <div>
        <InfoRegular fontSize={18} />
      </div>
      <Text weight="semibold" block>
        {t("hbh.noBenefits.label")}
      </Text>
    </NoBenefitsText>
  ) : (
    <>
      <EnrolledPackages />
      <EligiblePackagesWrap>
        <EligiblePackages />
      </EligiblePackagesWrap>
    </>
  );
}
const EligiblePackagesWrap = styled.div`
  margin: 20px 0;
  @media only screen and ${devices.md} {
    margin: 30px 0;
  }
`;

const NoBenefitsText = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px;
  max-width: 600px;
`;
